module.exports = __webpack_public_path__ + "static/media/2_2.e6d977fb.png";